module.exports = __webpack_public_path__ + "media/white_belt_illustration.c7231116.mp3";